import { render, staticRenderFns } from "./PromotionSelect.vue?vue&type=template&id=2f2f2ccb"
import script from "./PromotionSelect.vue?vue&type=script&lang=js"
export * from "./PromotionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports